import type { EnvironmentManager } from './envManager';
import EnvironmentManagerImpl from './envManagerImpl';
import type { SecretManager } from './secretManager';
import SecretManagerImpl from './secretManagerImpl';
import type { URLManager } from './urlManager';
import URLManagerImpl from './urlManagerImpl';

const environmentManager: EnvironmentManager = new EnvironmentManagerImpl();
const urlManager: URLManager = new URLManagerImpl(environmentManager);
const secretManager: SecretManager = new SecretManagerImpl();

export { environmentManager, urlManager, secretManager };
